'use client';

import { Schedule } from '@prisma/client';
import {
  ScheduleCreateInput,
  ScheduleDeleteInput,
  ScheduleUpdateInput,
  ScheduleUpgradeInput,
} from '@/models/schema';
import { handleNetworkError } from '@/lib/api/global';

export const getSchedule = async (scheduleId: string) => {
  const response = await fetch(`/api/schedules/${scheduleId}`);

  if (!response.ok) {
    handleNetworkError('schedule.errors.fetchFailed');
  }

  return (await response.json()) as Schedule;
};

export const addSchedule = async (scheduleInput: ScheduleCreateInput) => {
  const response = await fetch(`/api/schedules`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ ...scheduleInput }),
  });

  if (!response.ok) {
    handleNetworkError('Failed to create schedule');
  }

  return (await response.json()) as Schedule;
};

export const updateSchedule = async (scheduleInput: ScheduleUpdateInput) => {
  const response = await fetch(`/api/schedules/${scheduleInput.scheduleId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ ...scheduleInput }),
  });

  if (!response.ok) {
    handleNetworkError('Failed to update schedule');
  }

  return (await response.json()) as Schedule;
};

export const deleteSchedule = async (scheduleId: string) => {
  const scheduleInput = {
    scheduleId,
  } as ScheduleDeleteInput;

  const response = await fetch(`/api/schedules/${scheduleInput.scheduleId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ ...scheduleInput }),
  });

  if (!response.ok) {
    handleNetworkError('Failed to delete schedule');
  }

  return (await response.json()) as Schedule;
};

export const upgradeSchedule = async (scheduleInput: ScheduleUpgradeInput) => {
  const response = await fetch(`/api/schedules/${scheduleInput.scheduleId}/upgrade`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ ...scheduleInput }),
  });

  if (!response.ok) {
    handleNetworkError('Failed to update schedule');
  }

  return (await response.json()) as Schedule;
};
